import { t } from "@lingui/macro";

export function textWithLocaleInParentheses(textKey: string, shortLocale: string): string {
    return `${t({ id: textKey })} (${t({ id: `global.languages.${shortLocale}` })})`;
}
